module.exports = __webpack_public_path__ + "img/img6.d5e5cdc9.png";